export const APIUrl = {
    AUTOPOPULATE_LIST: '/csr/master/autopopulate/',
    PROJECT_UPSERT: '/csr/master/project/upsert/',
    USER_REGISTER: '/csr/users/register/',
    FORGET_PASSWORD: '/csr/auth/forget/password/',
    RESET_PASSWORD: '/csr/auth/reset/password/',
    MASTER_UPSERT: '/csr/master/values/upsert/',
    FORM_CONFIG_UPSERT: '/csr/form/configuration/upsert/',
    FORM_LIST: '/csr/form/configuration/list/',
    FORM_DETAILS: '/csr/form/configuration/details/',
    SUBMISSION_FORM_DETAILS: '/csr/form/submission/details/',
    SUBMISSION_FORM_UPSERT: '/csr/form/submission/upsert/',
    FORM_REPORT: '/csr/form/report/',
    PROJECT_REPORT: '/csr/form/project/report/',
    REPORT_PARAMETER: '/csr/form/report/filter/'
}